<script>
  import { emitter } from '@/main.js';
  import ProductListTopLeftBadge from '@/components/ProductListTopLeftBadge.vue';
  import ProductListBottomPillBadge from '@/components/ProductListBottomPillBadge.vue';
  import ProductListTextUnderBadge from '@/components/ProductListTextUnderBadge.vue';
  export default {
    components: {
      ProductListTopLeftBadge,
      ProductListBottomPillBadge,
      ProductListTextUnderBadge
    },
    name: 'ProductBadgePDP',
    data() {
      return {
        tags: [],
        badgeType: '',
        price: 0
      };
    },
    mounted() {
      const parentElement = this.$el.parentElement;
      this.badgeType = parentElement.getAttribute('data-badge-type');
      const initialPrice = parentElement.getAttribute('data-product-price');
      this.price = initialPrice ? parseFloat(initialPrice) : 0;
      emitter.on('pdp-tags-updated', e => {
        this.tags = e.tags;
      });
      emitter.on('updateAddButton', e => {
        if (e.variantPrice) {
          this.price = parseFloat(e.variantPrice) || 0;
        }
      });
    }
  };
</script>

<template>
  <component :is="badgeType" :tags="tags" :price="price" v-if="badgeType != ''"></component>
</template>
